/* ============
 * Email Transformer
 * ============
 *
 * Returns the information of the email that is about to be sent.
 * (Currently being implemented ONLY in bill edit).
 */

import Transformer from './transformer';

export default class EmailTransformer extends Transformer {

  static fetch(item) {
    return {
      toEmail: item.to_email,
      fromEmail: item.from_email,
      fromName: item.from_name,
      attachmentName: item.attachment_name,
      message: item.message,
      title: item.title,
      userEmail: item.user_email,
      commonEmail: item.common_email,
    };
  }

  static send(item) {
    return {
      to_email: item.toEmail,
      from_email: item.fromEmail,
      from_name: item.fromName,
      attachment_name: item.attachmentName,
      message: item.message,
      title: item.title,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/email.js